/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { get } from 'lodash';

// Components
import BaseInput from 'shared/ui/components/form-components/BaseInput.vue';
import DropdownMenu from 'shared/ui/components/DropdownMenu.vue';
import InputWithActions from 'shared/ui/components/form-components/InputWithActions.vue';
import RadioButtons from 'shared/ui/components/form-components/RadioButtons.vue';
import BadgeDesignPicker from 'ui/components/printing/BadgeDesignPicker.vue';

const __vue_script__ = {
    name: 'PrinterSettings',

    components: {
        BaseInput,
        DropdownMenu,
        InputWithActions,
        RadioButtons,
        BadgeDesignPicker
    },

    props: {
        event: {
            type: Object,
            required: true
        },

        config: {
            type: Object,
            default: () => ({})
        },

        registry: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            printers: get(this.registry, 'printer_kind.kind_options.choices', []),
            maxDesigns: 5,
            disabled: false,

            editing: -1,
            collapsedSections: [],
            title: '',

            innerValue: {
                pax_print_quantity: 1,
                printer_kind: '',
                zpl_codes: [],
                designs: [],
            }
        };
    },

    watch: {
        config: {
            immediate: true,
            handler() {
                this.innerValue.pax_print_quantity = this.config.pax_print_quantity;
                this.innerValue.printer_kind = this.config.printer_kind;
                this.innerValue.designs = this.config.designs || this.innerValue.zpl_codes || [];

                if (!this.innerValue.designs.length) {
                    this.addDesign();
                }
            }
        },

        /**
         * This is kept for backward compatiblity and could be safely
         * removed once iOS app will be fully upgraded
         */
        designs: {
            immediate: true,
            deep: true,
            handler() {
                this.innerValue.zpl_codes = this.innerValue.designs;
            }
        }
    },

    methods: {

        /**
         * handles save button click even if form is invalid
         * @param {boolean} isFormInvalid
         */
        handleClick(isFormInvalid) {
            if (isFormInvalid) {
                this.$emit('invalid');
            }
        },

        addDesign() {
            this.innerValue.designs.push({
                id: crypto.randomUUID(),
                name: this.getNextTitle(),
                targetable: this.innerValue.designs.length !== 0,
                deletable: this.innerValue.designs.length !== 0,
                code: ''
            });

            this.$utils.dom.scrollToId('#printer-settings-bottom');
        },

        save() {
            this.$emit('valid', this.innerValue);
        },

        updateDesigns(index, config) {
            this.innerValue.designs[index] = config;
        },

        /**
         * Toggles the specified section
         *
         * @param {string} section the section name to toggle
         */
        toggleSection(section) {
            if (this.collapsedSections.includes(section)) {
                this.collapsedSections = this.collapsedSections.filter(item => item !== section);
            } else {
                this.collapsedSections.push(section);
            }
        },

        /**
         * Starts the section name editing
         *
         * @param {number} index the section index to edit
         */
        rename(index) {
            this.title = this.innerValue.designs[index].name;
            this.editing = index;
        },

        getNextTitle(offset = 0) {
            const qty = this.innerValue.designs.length + offset;
            const name = this.$i18n.tc('onsite_scanning.settings.printer.designs.label', qty === 0 ? 1 : qty, [qty]);
            const nameTaken = this.innerValue.designs.some(({ name: item }) => item === name);

            return nameTaken ? this.getNextTitle(++offset) : name;
        },

        sectionTitle(index) {
            return this.innerValue.designs[index].name;
        },

        /**
         * Stops the editing of the section title
         */
        stopTitleEditing() {
            this.title = '';
            this.editing = -1;
        },

        /**
         * Sets the title for the section at index
         *
         * @param {number} index the index of the section
         */
        setTitle(index) {
            const section = this.innerValue.designs[index];
            section.name = this.title.length ? this.title : this.getNextTitle();

            this.stopTitleEditing();
        },

        /**
         * Prompts the user for the section removal
         *
         * @param {number} index the index of the section to remove
         */
        promptRemoval(index) {
            this.$modal.show('dialog', {
                title: this.$t('onsite_scanning.settings.printer.designs.section_removal_title'),
                text: this.$t('onsite_scanning.settings.printer.designs.section_removal'),
                buttons: [
                    {
                        title: this.$t('general.dismiss'),
                        default: true,
                        class: 'btn'
                    },
                    {
                        title: this.$t('general.delete'),
                        handler: async () => {
                            this.removeDesign(index);
                            this.$modal.hide('dialog');
                        },
                        class: 'btn btn-danger'
                    }
                ]
            });
        },

        /**
         * Removes the code from the list
         *
         * @param {number} index the index of the code to remove
         */
        removeDesign(index) {
            /** @type {object[]} */
            const sections = this.innerValue.designs;
            const section = sections[index];

            if (!section) {
                console.warn('[PrinterSettings] Specified section does not exist', index);
                return;
            }
            sections.splice(index, 1);
        },
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "onsite-scanning-settings subpage" },
    [
      _c("validation-observer", {
        attrs: { slim: true },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var handleSubmit = ref.handleSubmit
              var invalid = ref.invalid
              return [
                _c(
                  "form",
                  {
                    staticClass: "content",
                    on: {
                      submit: function ($event) {
                        $event.preventDefault()
                        return handleSubmit(_vm.save)
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "view-wrapper" },
                      [
                        _c("validation-provider", {
                          attrs: {
                            rules: "required",
                            slim: true,
                            name: "printer_kind",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (ref) {
                                  var errors = ref.errors
                                  return [
                                    _c("radio-buttons", {
                                      attrs: {
                                        name: "printer_kind",
                                        label: _vm.$t(
                                          "onsite_scanning.settings.printer.printer_kind.label"
                                        ),
                                        options: _vm.printers,
                                        errors: errors,
                                      },
                                      model: {
                                        value: _vm.innerValue.printer_kind,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.innerValue,
                                            "printer_kind",
                                            $$v
                                          )
                                        },
                                        expression: "innerValue.printer_kind",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                        _c("validation-provider", {
                          attrs: {
                            rules: "required|integer|numeric",
                            slim: true,
                            name: "pax_print_quantity",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (ref) {
                                  var errors = ref.errors
                                  return [
                                    _c("base-input", {
                                      staticClass: "small-input",
                                      attrs: {
                                        type: "number",
                                        name: "pax_print_quantity",
                                        min: "1",
                                        label: _vm.$t(
                                          "onsite_scanning.settings.printer.pax_print_quantity.label"
                                        ),
                                        "hint-after-label": true,
                                        hint: _vm.$t(
                                          "onsite_scanning.settings.printer.pax_print_quantity.hint"
                                        ),
                                        errors: errors,
                                      },
                                      model: {
                                        value:
                                          _vm.innerValue.pax_print_quantity,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.innerValue,
                                            "pax_print_quantity",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "innerValue.pax_print_quantity",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                        _c("div", { staticClass: "actions" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary btn-ctx-icon",
                              attrs: {
                                type: "button",
                                disabled:
                                  _vm.innerValue.designs.length >=
                                  _vm.maxDesigns,
                              },
                              on: { click: _vm.addDesign },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "onsite_scanning.settings.printer.add_design"
                                  )
                                )
                              ),
                              _c("i", { staticClass: "ic-plus" }),
                            ]
                          ),
                        ]),
                        _vm._l(_vm.innerValue.designs, function (zpl, index) {
                          return _c("badge-design-picker", {
                            class: {
                              collapsed: _vm.collapsedSections.includes(index),
                            },
                            attrs: {
                              value: zpl,
                              event: _vm.event,
                              name: "design_" + index,
                            },
                            on: {
                              change: function (data) {
                                return _vm.updateDesigns(index, data)
                              },
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "top-header",
                                  fn: function () {
                                    return [
                                      _vm.editing !== index
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "title-and-actions",
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "actions" },
                                                [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass: "toggler",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.toggleSection(
                                                            index
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "ic-chevron-up",
                                                      }),
                                                    ]
                                                  ),
                                                  _c(
                                                    "dropdown-menu",
                                                    { staticClass: "embedded" },
                                                    [
                                                      _c("ul", [
                                                        _c("li", [
                                                          _c(
                                                            "a",
                                                            {
                                                              staticClass:
                                                                "has-action rename",
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    $event.preventDefault()
                                                                    return _vm.rename(
                                                                      index
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "ic-edit",
                                                              }),
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "general.rename"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]),
                                                        zpl.deletable
                                                          ? _c("li", [
                                                              _c(
                                                                "a",
                                                                {
                                                                  staticClass:
                                                                    "has-action delete danger",
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        $event.preventDefault()
                                                                        return _vm.promptRemoval(
                                                                          index
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _c("i", {
                                                                    staticClass:
                                                                      "ic-trash-2",
                                                                  }),
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "general.delete"
                                                                      )
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ])
                                                          : _vm._e(),
                                                      ]),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "span",
                                                { staticClass: "title" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.sectionTitle(index)
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "title-and-actions editing",
                                            },
                                            [
                                              _c("validation-provider", {
                                                attrs: {
                                                  slim: true,
                                                  name: "title",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function (ref) {
                                                        var errors = ref.errors
                                                        return [
                                                          _c(
                                                            "input-with-actions",
                                                            {
                                                              attrs: {
                                                                type: "text",
                                                                name: "title",
                                                                errors: errors,
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.title,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.title =
                                                                      $$v
                                                                  },
                                                                expression:
                                                                  "title",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "button",
                                                                {
                                                                  staticClass:
                                                                    "btn",
                                                                  attrs: {
                                                                    type: "button",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.stopTitleEditing()
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "general.cancel"
                                                                      )
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "button",
                                                                {
                                                                  staticClass:
                                                                    "btn btn-success",
                                                                  attrs: {
                                                                    type: "button",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.setTitle(
                                                                          index
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "general.accept"
                                                                      )
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                            ],
                                            1
                                          ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              true
                            ),
                          })
                        }),
                      ],
                      2
                    ),
                    _c("secondary-toolbar", [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary",
                          on: {
                            click: function ($event) {
                              return _vm.handleClick(invalid)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("general.save")))]
                      ),
                    ]),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
      _c("div", { attrs: { id: "printer-settings-bottom" } }),
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/components/printing/PrinterSettings.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__